const MONTHLY_YEARLY_UPGRADE_PLAN_MAP = {
  'pro-monthly': 'pro-yearly',
  'essential-monthly': 'essential-yearly',
}

export { MONTHLY_YEARLY_UPGRADE_PLAN_MAP }
